const STORAGE_KEY = "pushNotificationSetting";

const True = "true";
const False = "false";

export const getIsPushNotificationSettingEnabled = () => {
  const setting = localStorage.getItem(STORAGE_KEY);

  return setting === True || setting === null;
};

export const getIsPushNotificationSettingDisabled = () => {
  const setting = localStorage.getItem(STORAGE_KEY);

  return setting === False;
};

export const setPushNotificationSetting = (value: boolean) => {
  localStorage.setItem(STORAGE_KEY, String(value));
};

export const clearPushNotificationSetting = () => {
  localStorage.removeItem(STORAGE_KEY);
};

export const isSubscribed = async () => {
  const registration = await navigator.serviceWorker?.ready;

  return registration?.pushManager?.getSubscription();
};

export const unsubscribeFromPush = async (isLogoutAction = false) => {
  const registration = await navigator.serviceWorker?.ready;
  const subscription = await registration?.pushManager?.getSubscription();

  if (subscription) {
    await subscription.unsubscribe();
    if (!isLogoutAction) {
      setPushNotificationSetting(false);
    }
  }
};
